import { Grid2 } from "@mui/material";
import React from "react";
import EmptyListUi from "../../../EmptyListUi";
import ServiceTypeInputChip from "../ServiceTypeInputChip";

const ServiceTypeList = ({
  list,
  setServiceTypes,
  edit,
  fetchedServiceTypes,
  setServiceTypeIdsToDelete,
  isDefault = false // NEW: Added isDefault prop
}) => {
  return (
    <Grid2 container spacing={2} mt={2}>
      {list.length === 0 ? (
        <EmptyListUi text="No Service Types 😅" />
      ) : (
        list.map((type) => (
          <ServiceTypeInputChip
            key={type.id}
            type={type}
            setServiceTypes={setServiceTypes}
            fetchedServiceTypes={fetchedServiceTypes}
            edit={edit}
            setServiceTypeIdsToDelete={setServiceTypeIdsToDelete}
            isDefault={isDefault} // NEW: Pass isDefault to each chip
          />
        ))
      )}
    </Grid2>
  );
};

export default ServiceTypeList;
